import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "../../../components/common/appHeader/AppHeader";
import dayjs from "dayjs";
// import NotiBox from "./../../../components/common/notiBox/notiBox";
// import DataSection from "@src/components/form/dataSection/DataSection";
// import Checkbox from "../../../components/common/checkbox/Checkbox";
// import RedBoxList from "./../../../components/booking/redBoxList/RedBoxList";
import TextArea from "./../../../components/common/textArea/TextArea";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useRecommendHall } from "../../../utils/hooks/useRecommendHall";
import {
  setDays,
  setTime,
  setYearMonths,
  setAdditionalInquiry,
  // setAlternativeSchedules,
  setImportantFactors,
} from "@src/@slice/recommendHallSlice";
import NotificationArccodion from "@src/components/booking/realtimeBooking/notification/NotificationArccodion";
import { Blank, BottomFixedModal } from "@src/shared/src";

const MonthSelectArea = () => {
  const navigate = useNavigate();
  const now = dayjs();
  const peakMonths = [3,4,5,6,9,10,11,12];
  const lowMonths = [1,2,7,8]
  const { hallData, dispatch } = useRecommendHall();

  useEffect(() => {
    if (
      hallData.hallStyleTypes.length === 0 ||
      hallData.weddingType === "" ||
      hallData.weddingRegions.length === 0 ||
      (hallData.expectedPerson.min === null && hallData.expectedPerson.max === null) ||
      hallData.meal.types.length === 0 ||
      (hallData.meal.minPrice === null && hallData.meal.maxPrice === null)
    ) {
      navigate("/recommend/hall/start", { replace: true });
    }
  }, []);

  return (
    <div className="month-selector-wrap" style={{marginRight: '-20px'}}>
      <p className="apply-form-content-title">{`날짜선택(최대 4개)`}</p>
      <div key={`${now.get("year")}-month-wrap`}>
        <p className="apply-form-content-title" style={{color:'#8A8A8A'}}>성수기</p>
        <div className={`scroll-able-btn-wrap`}>
          {peakMonths.map(month =>  
            <button 
              key={`month-btn-${month}`} 
              className={`btn btn-gray ${hallData.hopeWedding.yearMonths.indexOf(`${month}월`) > -1 ? 'selected' :''}`}
              onClick={()=>{
                dispatch(setYearMonths({ date: `${month}월` }))
              }}
              >
              {month}월
            </button>)}
        </div>
        <Blank height={10}/>
        <p className="apply-form-content-title" style={{color:'#8A8A8A'}}>비수기</p>
        <div className={`scroll-able-btn-wrap`}>
          {lowMonths.map(month =>  
            <button key={`month-btn-${month}`}
            className={`btn btn-gray ${hallData.hopeWedding.yearMonths.indexOf(`${month}월`) > -1 ? 'selected' :''}`}
              onClick={()=>{
                dispatch(setYearMonths({ date: `${month}월` }))
              }}
              >
              {month}월
            </button>)}
        </div>
      </div>
    </div>
  );
};

const strData = {
  days: ["토요일", "일요일", "평일"],
  times: ['오전', '점심', '오후', '저녁'],
  importantFactors: [
    "평균보다 가격이 저렴한 웨딩홀",
    "홀 분위기, 식사의 퀄리티가 높은 웨딩홀",
    "예상 보증인원 조건에 맞는 웨딩홀",
    "교통과 주차환경이 편한 웨딩홀",
  ],
};

const HopeDate = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(true);
  const [showSelectionSheet, setShowSelectioSheet] = useState(false);
  const { hallData, dispatch } = useRecommendHall();

  useEffect(() => {

    if (
      hallData.hopeWedding.yearMonths.length === 0 ||
      hallData.hopeWedding.days.length === 0 ||
      hallData.hopeWedding.times.length === 0 ||
      hallData.importantFactors.length === 0
    ) {
      setValidate(false);
    } else {
      setValidate(true);
    }
  }, [hallData.hopeWedding, hallData.importantFactors]);

  const goNext = () => {
    // navigate("/recommend/hall/etc-info");
    navigate("/recommend/hall/customer-info");
  };
  return (
    <>
      <AppHeader type="stack" actionItems={[{ name: "close" }]} />
      <div>
        <PageTitle title={`희망 예식 일정을 알려주세요.`}/>
        <div className="common-wrap  page-apply-form">
        <MonthSelectArea />
         <ul className={`${hallData.hopeWedding.yearMonths.length > 0 ? "selected-chips-list-wrap" : ''}`}>
          {hallData.hopeWedding.yearMonths.map((month, idx) => (
            <li key={`month-chip-${idx}`}>
              <span>{month}</span>
              <button
                className="btn btn-icon"
                onClick={() =>dispatch(setYearMonths({ date: month }))}
              >
                <i className="icon icon-x-gray500-18" />
              </button>
            </li>
          ))}
        </ul>
        <div className="divider"/>
        <p className="apply-form-content-title">요일선택</p>
        <div className={`scroll-able-btn-wrap`}>
          {strData.days.map(day =>  
            <button 
              key={`month-btn-${day}`} 
              className={`btn btn-gray ${hallData.hopeWedding.days.indexOf(day) > -1 ? 'selected' :''}`}
              onClick={() => dispatch(setDays({ day: day }))}
              >
              {day}
            </button>)}
        </div>
        <ul className={`${hallData.hopeWedding.days.length > 0 ? "selected-chips-list-wrap" : ''}`}>
          {hallData.hopeWedding.days.map((day,idx) => (
            <li key={`day-chip-${idx}`}>
              <span>{day}</span>
              <button
                className="btn btn-icon"
                onClick={() =>dispatch(setDays({ day: day }))}
              >
                <i className="icon icon-x-gray500-18" />
              </button>
            </li>
          ))}
        </ul>
        <div className="divider"/>
        <p className="apply-form-content-title">시간선택</p>
        <div className={`scroll-able-btn-wrap`} style={{marginBottom:'16px'}}>
          {strData.times.map((time,idx) =>  
            <button 
              key={`time-btn-${idx}`} 
              className={`btn btn-gray ${hallData.hopeWedding.times.indexOf(time) > -1 ? 'selected' :''}`}
              onClick={() => dispatch(setTime({ time: time }))}
              >
              {time}
            </button>)}
        </div>
        <ul className={`${hallData.hopeWedding.times.length > 0 ? "selected-chips-list-wrap" : ''}`}>
        {hallData.hopeWedding.times.map((time,idx) => (
          <li key={`time-chip-${idx}`}>
            <span>{time}</span>
            <button
              className="btn btn-icon"
              onClick={() => dispatch(setTime({ time: time }))}
            >
              <i className="icon icon-x-gray500-18" />
            </button>
          </li>
        ))}
        </ul>
        <NotificationArccodion  className='recommend-hall-noti'  isOpen={true} title='시간 안내' useArccodion={false}>
          <p>{`오전: 9시 ~ 11시 대 / 점심: 12시 ~ 14시 대
          오후: 15시 ~ 16시 대 / 저녁: 17시 ~ `}
          </p>
        </NotificationArccodion>
        <NotificationArccodion  className='recommend-hall-noti' isOpen={true} title='희망 예식 일정 선택 시 참고해 주세요.' useArccodion={false}>
          <p>예식 날짜와 시간대에 따라 보증인원 조건과 비용이 달라집니다. 아래의 보증인원 및 비용이 높은 순서를 참고하여 선택해보세요.</p>
          <ul>
            <li>{`성수기 > 비수기 예식`}</li>
            <li>{`토요일 > 일요일 > 금요일 예식`}</li>
            <li>{`점심 > 오전&오후 > 저녁 시간대 예식`}</li>
          </ul>
        </NotificationArccodion>
        <div className="divider"/>
        <div style={{padding: '16px 0'}}>
          <h3 className="apply-form-content-title">웨딩홀 결정 시 가장 중요한 점은 무엇인가요?</h3>
          <div className="select select-full select-gray select-alternative-schedules" 
            onClick={()=>{setShowSelectioSheet(true)}}>
            <span style={{color: hallData.importantFactors === ''? '': '#191919'}}>{hallData.importantFactors === '' ? '선택' : hallData.importantFactors}</span>
          </div>
        </div>
        <div className="divider"/>
        <div style={{padding: '16px 0'}}>
          <h3 className="apply-form-content-title">추가 문의 내용을 적어주세요.</h3>
          <TextArea
            className="textarea textarea textarea-has-line"
            style={{ height: 96 }}
            placeholder={`예) 다음 주에 투어 원해요.\n금액이 궁금해요.\n보증인원 최소로 진행하고 싶어요.`}
            defaultValue={hallData.hopeWedding.additionalInquiry}
            value={hallData.hopeWedding.additionalInquiry}
            onChange={(e) => {
              dispatch(setAdditionalInquiry({ data: e.target.value }));
            }}
          />
        </div>
        </div>
        <div className="btn-wrap">
          <button
            disabled={!validate}
            className={`btn btn-giant btn-full btn-red500 ${!validate ? "btn-disabled" : ""}`}
            onClick={goNext}
          >
            다음
          </button>
          <BottomFixedModal 
            className="region-bottom-fixed-modal"
            isShow={showSelectionSheet} 
            title="웨딩홀 결정 시 중요한 점은 무엇인가요?"
            isTransition={true}
            hideModal={()=>{setShowSelectioSheet(false)}}
          >
            <ul>        
              {strData.importantFactors.map((fact,idx) => (
                <li key={`important-opt-${idx}`}
                  className={`selected-with-check ${fact === hallData.importantFactors ? 'selected bold' : ''}`}
                  style={{display:'flex', justifyContent:'space-between'}}
                  value={fact}
                  onClick={() => {
                    // setImportantFactor(fact);
                    dispatch(setImportantFactors({ data: fact }));
                    setShowSelectioSheet(false);
                  }}
                >
                  {fact}
                  { fact === hallData.importantFactors && 
                    <span>
                      <i className="icon icon-checkmark-brown500"></i>
                    </span>
                  }
                </li>
              ))}
            </ul>
          </BottomFixedModal>
        </div>
      </div>
    </>
  );
};

export default HopeDate;
